export const checkActiveAI = (item, aiType) => {
  if (!item?.id) {
    return false;
  }

  const aisType = aiType === 'waitesWireless' ? 'activeWwAi' : 'activeRegularAi';

  return item[aisType];
};
